/**
 * Labstep
 *
 * @module components/Entity/Action/AddSearch/Bulk
 * @desc Action to add. Shows modal to select entity to be added to.
 */

import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { EntityToggleContainer } from 'labstep-web/containers/Entity/Toggle';
import { ActionComponentBulk as BulkActionComponent } from 'labstep-web/core/Action/Component/Bulk';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import { SearchSelectContainer as SearchSelect } from 'labstep-web/core/Select/Search';
import type React from 'react';
import type {
  EntityActionAddSearchBulkContainerProps,
  EntityActionAddSearchBulkProps,
} from './types';

export const EntityActionAddSearchBulk: React.FC<
  EntityActionAddSearchBulkProps
> = ({
  entityName,
  parentId,
  activeGroup,
  options,
  parentName,
  header,
  viewComponent,
  searchSelectProps,
  disclaimer,
}) => (
  <ModalDefault
    data-cy="components/Entity/Action/AddSearch/Bulk:modal"
    header={header}
    content={({ toggleModal }) => (
      <EntityToggleContainer
        action="add"
        entityName={entityName}
        parentName={parentName}
        parentId={parentId}
      >
        {({ toggle }) => (
          <>
            {disclaimer}
            <SearchSelect
              labelKey="name"
              autoFocus
              openMenuOnFocus
              creatable
              createBody={{
                type: parentName,
              }}
              params={{
                type: parentName,
                group_id: activeGroup?.id,
              }}
              entityName={entityName}
              value={null}
              onChange={(selectedOption) => {
                toggle(undefined, selectedOption.id, {
                  ...options,
                  toast: true,
                });
                toggleModal();
              }}
              {...searchSelectProps}
            />
          </>
        )}
      </EntityToggleContainer>
    )}
    viewComponent={viewComponent}
  />
);

export const EntityActionAddSearchBulkWithGroup = withActiveGroup(
  EntityActionAddSearchBulk,
);

export const EntityActionAddSearchBulkContainer: React.FC<
  EntityActionAddSearchBulkContainerProps
> = ({
  parentEntities,
  parentEntitiesWithPermission,
  options,
  entityName,
  actionText,
  icon,
  searchSelectProps,
  dataCy,
  disclaimer,
}) => {
  const parentName =
    parentEntitiesWithPermission[0] &&
    parentEntitiesWithPermission[0].entityName;

  return (
    <EntityActionAddSearchBulkWithGroup
      options={options}
      entityName={entityName}
      parentName={parentName}
      header={actionText}
      parentId={parentEntitiesWithPermission.map((e) => e.id)}
      viewComponent={({ toggleModal }) => (
        <BulkActionComponent
          dataCy={dataCy}
          entitiesWithPermissionCount={
            parentEntitiesWithPermission.length
          }
          entitiesSelectedCount={parentEntities.length}
          onClick={toggleModal}
          content={actionText}
          icon={icon}
        />
      )}
      searchSelectProps={searchSelectProps}
      disclaimer={disclaimer}
    />
  );
};
